"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _tree = require("./tree");
// i18next-extract-mark-ns-start Trees

// eslint-disable-next-line max-lines-per-function
var getTreeCreation = function getTreeCreation(t) {
  var pricingVersion = (0, _tree.getPricingVersion)();
  return [{
    name: t('Tote bag'),
    slug: 'crea_tote',
    questions: [{
      slug: 'shape',
      label: t('La forme de votre accessoire sera plutôt :'),
      answers: [{
        slug: 'SIMPLE',
        label: t('Simple'),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561548/tilli-core/tote_bag_simple.jpg'
      }, {
        slug: 'COMPLEX',
        label: t('Originale'),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561544/tilli-core/tote_bag_original.jpg'
      }]
    }, {
      slug: 'size',
      label: t('Quelle sera la taille de votre accessoire ?'),
      answers: [{
        slug: 'SMALL',
        label: t('Classique côtés < 50cm'),
        id: "".concat(pricingVersion, ".crea_tote-dime-1")
      }, {
        slug: 'BIG',
        label: t('Grand côtés > 51cm'),
        id: "".concat(pricingVersion, ".crea_tote-dime-2")
      }]
    }, {
      slug: 'handle',
      label: t('Quel matériau préférez-vous pour l’anse du sac ?'),
      answers: [{
        slug: 'chainHandle',
        label: t('En chaîne'),
        id: "".concat(pricingVersion, ".crea_tote-anse-1")
      }, {
        slug: 'fabricHandle',
        label: t('En tissu'),
        id: "".concat(pricingVersion, ".crea_tote-anse-2")
      }, {
        slug: 'otherHandle',
        label: t('Autre*'),
        id: "".concat(pricingVersion, ".crea_tote-anse-3")
      }]
    }, {
      slug: 'closing',
      label: t('Quelle type de fermeture souhaitez-vous ?'),
      answers: [{
        slug: 'buttonClosing',
        label: t('Avec bouton classique'),
        id: "".concat(pricingVersion, ".crea_tote-ferm-1")
      }, {
        slug: 'pressStudClosing',
        label: t('Avec bouton pression'),
        id: "".concat(pricingVersion, ".crea_tote-ferm-2")
      }, {
        slug: 'zipClosing',
        label: t('Avec une fermeture éclair'),
        id: "".concat(pricingVersion, ".crea_tote-ferm-4")
      }, {
        slug: 'noClosing',
        label: t('Aucun')
      }]
    }]
  },
  // *****************************************************
  // ************************ SAC ************************
  // *****************************************************

  {
    name: t('Sac'),
    slug: 'crea_sac',
    questions: [{
      slug: 'shape',
      label: t('La forme de votre accessoire sera plutôt :'),
      answers: [{
        slug: 'SIMPLE',
        label: t('Simple'),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561550/tilli-core/sac_simple.jpg'
      }, {
        slug: 'COMPLEX',
        label: t('Originale'),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561543/tilli-core/sac_originale.jpg'
      }]
    }, {
      slug: 'size',
      label: t('Quelle sera la taille de votre accessoire ?'),
      answers: [{
        slug: 'SMALL',
        label: t('Petit côtés < 35cm'),
        id: "".concat(pricingVersion, ".crea_sac-dime-1")
      }, {
        slug: 'MEDIUM',
        label: t('Moyen 36cm < côtés < 50cm'),
        id: "".concat(pricingVersion, ".crea_sac-dime-2")
      }, {
        slug: 'BIG',
        label: t('Grand côtés > 51cm'),
        id: "".concat(pricingVersion, ".crea_sac-dime-3")
      }]
    }, {
      slug: 'handle',
      label: t('Quel matériau préférez-vous pour l’anse du sac ?'),
      answers: [{
        slug: 'chainHandle',
        label: t('En chaîne'),
        id: "".concat(pricingVersion, ".crea_sac-anse-1")
      }, {
        slug: 'fabricHandle',
        label: t('En tissu'),
        id: "".concat(pricingVersion, ".crea_sac-anse-2")
      }, {
        slug: 'otherHandle',
        label: t('Autre*'),
        id: "".concat(pricingVersion, ".crea_sac-anse-3")
      }]
    }, {
      slug: 'closing',
      label: t('Quelle type de fermeture souhaitez-vous ?'),
      answers: [{
        slug: 'buttonClosing',
        label: t('Avec bouton classique'),
        id: "".concat(pricingVersion, ".crea_sac-ferm-1")
      }, {
        slug: 'pressStudClosing',
        label: t('Avec bouton pression'),
        id: "".concat(pricingVersion, ".crea_sac-ferm-2")
      }, {
        slug: 'zipClosing',
        label: t('Avec une fermeture éclair'),
        id: "".concat(pricingVersion, ".crea_sac-ferm-4")
      }, {
        slug: 'noClosing',
        label: t('Aucun')
      }]
    }]
  },
  // **********************************************
  // ****************** POCHETTE ******************
  // **********************************************

  {
    name: t('Pochette'),
    slug: 'crea_poch',
    questions: [{
      slug: 'shape',
      label: t('La forme de votre accessoire sera plutôt :'),
      answers: [{
        slug: 'SIMPLE',
        label: t('Simple'),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561541/tilli-core/pochette_simple.jpg'
      }, {
        slug: 'COMPLEX',
        label: t('Originale'),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561540/tilli-core/pochette_originale.jpg'
      }]
    }, {
      slug: 'size',
      label: t('Quelle sera la taille de votre accessoire ?'),
      answers: [{
        slug: 'SMALL',
        label: t('Petit 15x10cm'),
        id: "".concat(pricingVersion, ".crea_poch-dime-1")
      }, {
        slug: 'MEDIUM',
        label: t('Moyen 20x20cm'),
        id: "".concat(pricingVersion, ".crea_poch-dime-2")
      }, {
        slug: 'BIG',
        label: t('Grand > 25cm'),
        id: "".concat(pricingVersion, ".crea_poch-dime-3")
      }]
    }, {
      slug: 'handle',
      label: t('Quel matériau préférez-vous pour l’anse de la pochette ?'),
      answers: [{
        slug: 'chainHandle',
        label: t('En chaîne'),
        id: "".concat(pricingVersion, ".crea_poch-anse-1")
      }, {
        slug: 'fabricHandle',
        label: t('En tissu'),
        id: "".concat(pricingVersion, ".crea_poch-anse-2")
      }, {
        slug: 'otherHandle',
        label: t('Autre*'),
        id: "".concat(pricingVersion, ".crea_poch-anse-3")
      }, {
        slug: 'noHandle',
        label: t('Aucune')
      }]
    }, {
      slug: 'closing',
      label: t('Quelle type de fermeture souhaitez-vous ?'),
      answers: [{
        slug: 'buttonClosing',
        label: t('Avec bouton classique'),
        id: "".concat(pricingVersion, ".crea_poch-ferm-1")
      }, {
        slug: 'pressStudClosing',
        label: t('Avec bouton pression'),
        id: "".concat(pricingVersion, ".crea_poch-ferm-2")
      }, {
        slug: 'zipClosing',
        label: t('Avec une fermeture éclair'),
        id: "".concat(pricingVersion, ".crea_poch-ferm-4")
      }, {
        slug: 'noClosing',
        label: t('Aucun')
      }]
    }]
  },
  // *****************************************************
  // *********************** HOUSSE **********************
  // *****************************************************

  {
    name: t('Housse de coussin'),
    slug: 'crea_hous',
    questions: [{
      slug: 'range',
      label: t('Combien de housses de coussin ?')
    }, {
      slug: 'shape',
      label: t('La forme de votre accessoire sera plutôt :'),
      answers: [{
        slug: 'SIMPLE',
        label: t('Simple'),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561536/tilli-core/housse_simple.jpg'
      }, {
        slug: 'COMPLEX',
        label: t('Originale'),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561536/tilli-core/housse_originale.jpg'
      }]
    }, {
      slug: 'size',
      label: t('Quelle sera la taille de votre accessoire ?'),
      answers: [{
        slug: 'SMALL',
        label: t('Petit < 45cm'),
        id: "".concat(pricingVersion, ".crea_hous-dime-1")
      }, {
        slug: 'BIG',
        label: t('Grand > 45cm'),
        id: "".concat(pricingVersion, ".crea_hous-dime-2")
      }]
    }, {
      slug: 'closing',
      label: t('Quelle type de fermeture souhaitez-vous ?'),
      answers: [{
        slug: 'buttonClosing',
        label: t('Avec bouton classique'),
        id: "".concat(pricingVersion, ".crea_hous-ferm-1")
      }, {
        slug: 'invisibleZip',
        label: t('Avec un zip invisible'),
        id: "".concat(pricingVersion, ".crea_hous-ferm-6")
      }, {
        slug: 'zipClosing',
        label: t('Avec une fermeture éclair'),
        id: "".concat(pricingVersion, ".crea_hous-ferm-4")
      }, {
        slug: 'noClosing',
        label: t('Aucun')
      }]
    }]
  },
  // *****************************************************
  // ***************** PLAID/COUVRE-LIT ******************
  // *****************************************************

  {
    name: t('Plaid/Couvre-lit'),
    slug: 'crea_plai',
    questions: [{
      slug: 'size',
      label: t('Quelle est la taille de votre plaid/couvre-lit ?'),
      answers: [{
        slug: 'SMALL',
        label: t('Petit côté < à 99cm inclus'),
        id: "".concat(pricingVersion, ".crea_plai-dime-1")
      }, {
        slug: 'MEDIUM',
        label: t('Moyen côté < à 199cm inclus'),
        id: "".concat(pricingVersion, ".crea_plai-dime-2")
      }, {
        slug: 'BIG',
        label: t('Grand côté < à 300cm inclus'),
        id: "".concat(pricingVersion, ".crea_plai-dime-3")
      }]
    }, {
      slug: 'lining',
      label: t('Souhaitez-vous le doubler ?'),
      answers: [{
        slug: 'withLining',
        label: t('Avec doublure'),
        id: "".concat(pricingVersion, ".crea_plai-supp-1")
      }, {
        slug: 'withoutLining',
        label: t('Sans doublure')
      }, {
        slug: 'undefined',
        label: t('Je ne sais pas')
      }]
    }, {
      slug: 'duffel',
      label: t('Souhaitez-vous ajouter du molleton ?'),
      answers: [{
        slug: 'withDuffel',
        label: t('Avec molleton'),
        id: "".concat(pricingVersion, ".crea_plai-supp-2")
      }, {
        slug: 'withoutDuffel',
        label: t('Sans molleton')
      }, {
        slug: 'undefined',
        label: t('Je ne sais pas')
      }]
    }]
  },
  // *****************************************************
  // ********************** RIDEAUX **********************
  // *****************************************************

  {
    name: t('Rideaux'),
    slug: 'crea_ride',
    questions: [{
      slug: 'shape',
      label: t('Souhaitez-vous une paire de rideaux ?'),
      answers: [{
        slug: 'COMPLEX',
        label: t('Oui')
      }, {
        slug: 'SIMPLE',
        label: t('Non')
      }]
    }, {
      slug: 'size',
      label: t('Quelle est la longueur de votre tringle ? (sans les embouts)'),
      answers: [{
        slug: 'SMALL',
        label: t('Inférieur à 140cm'),
        id: "".concat(pricingVersion, ".crea_ride-dime-1")
      }, {
        slug: 'MEDIUM',
        label: t('Inférieur à 200cm'),
        id: "".concat(pricingVersion, ".crea_ride-dime-2")
      }, {
        slug: 'BIG',
        label: t('Inférieur à 300cm'),
        id: "".concat(pricingVersion, ".crea_ride-dime-3")
      }, {
        slug: 'HUGE',
        label: t('Inférieur à 400cm'),
        id: "".concat(pricingVersion, ".crea_ride-dime-4")
      }]
    }, {
      slug: 'height',
      label: t('Quelle est la hauteur de vos rideaux ? (de la tringle jusqu’au sol)'),
      answers: [{
        slug: 'SHORT',
        label: t('Inférieur à 200cm'),
        id: "".concat(pricingVersion, ".crea_ride-haut-1")
      }, {
        slug: 'MIDDLE',
        label: t('Inférieur à 300cm'),
        id: "".concat(pricingVersion, ".crea_ride-haut-2")
      }, {
        slug: 'LONG',
        label: t('Inférieur à 400cm'),
        id: "".concat(pricingVersion, ".crea_ride-haut-3")
      }]
    }, {
      slug: 'head',
      label: t('Quelle tête de rideau souhaitez-vous ?'),
      answers: [{
        slug: 'hidden',
        label: t('Pattes cachées'),
        id: "".concat(pricingVersion, ".crea_ride-tete-1"),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561540/tilli-core/pattes_cachees.jpg'
      }, {
        slug: 'visible',
        label: t('Pattes apparentes'),
        id: "".concat(pricingVersion, ".crea_ride-tete-2"),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561539/tilli-core/pattes_apparentes.jpg'
      }, {
        slug: 'stripes',
        label: t('Galon fronceur'),
        id: "".concat(pricingVersion, ".crea_ride-tete-3"),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561535/tilli-core/galon_fronceur.jpg'
      }, {
        slug: 'knots',
        label: t('Nouettes'),
        id: "".concat(pricingVersion, ".crea_ride-tete-4"),
        image: 'https://res.cloudinary.com/tilli/image/upload/v1709561539/tilli-core/nouettes.jpg'
      }, {
        slug: 'seeInRDV',
        label: t('Voir en RDV')
      }]
    }, {
      slug: 'liningLastQuestion',
      label: t('Souhaitez-vous une doublure ?'),
      answers: [{
        slug: 'withLining',
        label: t('Avec doublure'),
        id: "".concat(pricingVersion, ".crea_ride-supp-1")
      }, {
        slug: 'withoutLining',
        label: t('Sans doublure')
      }, {
        slug: 'seeInRDV',
        label: t('Voir en RDV')
      }]
    }, {
      slug: 'range',
      label: t('Combien de [replace] identiques souhaitez-vous créer ?'),
      subLabels: {
        COMPLEX: t('paires de rideaux'),
        SIMPLE: t('rideaux')
      }
    }]
  }];
};
var _default = exports["default"] = getTreeCreation;